import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-cards-credit-activation-declined',
	templateUrl: './declined.component.html',
	styleUrls: ['./declined.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CardsCreditActivationDeclinedComponent implements OnInit {

	constructor() {}

	ngOnInit(): void {
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/cards-activation/credit/activation/declined/declined.component.ts